<template>
  <div
    class="product"
    id="product"
  >
    <div class="listLogo">
      <img
        src="../../assets/img/listLogo.png"
        alt
      />
      <span>能力列表</span>
    </div>
    <div class="titileContent">
      <div class="formContainer">
        <el-form
          label-suffix=":"
          :inline="true"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item label="快速查询">
            <el-input
              placeholder="请输入能力名称"
              v-model.trim="filterForm.nameOrType"
              clearable
              @input="handleSearch"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button class="addBtn" type="primary"
                   icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <el-button type="danger"
                   :disabled="!selectRows.length"
                   icon="el-icon-delete" @click="handleBatchDelete">删除</el-button>
      </div>
    </div>
    <div class="content">
      <CustomTable
          ref="table"
          :data="tableData"
          :listQuery="listQuery"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" reserve-selection></el-table-column>
        <el-table-column label="能力名称" prop="name"></el-table-column>
        <el-table-column label="能力说明" prop="instruction"></el-table-column>
        <el-table-column label="英文名称" prop="type"></el-table-column>
        <el-table-column label="创建者" prop="creator"></el-table-column>
        <el-table-column label="创建时间" prop="createTime" width="180">
          <template slot-scope="scope">
            <span>{{scope.row.createTime|formatDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </CustomTable>
    </div>
    <!--添加客户-->
    <KLDialog :visible="productDialogVisible" @close="handleCloseDialog" @submit="handleSubmit">
      <div slot="title">{{isEdit?'编辑能力':'新增能力'}}</div>
      <el-form ref="productForm" :model="productForm" :rules="productFormRules" label-width="100px" label-position="left">
        <el-form-item label="能力名称" prop="name">
          <el-input v-model="productForm.name" placeholder="请输入能力名称"></el-input>
        </el-form-item>
        <el-form-item label="英文标识" prop="type">
          <el-input v-model="productForm.type" placeholder="请输入能力英文标识"></el-input>
        </el-form-item>
        <el-form-item label="能力说明" prop="instruction">
          <span slot="label" style="margin-left: 10px">能力说明</span>
          <el-input v-model="productForm.instruction" placeholder="请输入能力说明"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <span slot="label" style="margin-left: 10px">备注</span>
          <el-input v-model="productForm.note" placeholder="请输入能力备注"></el-input>
        </el-form-item>
      </el-form>
    </KLDialog>
  </div>
</template>

<script>
import Moment from 'moment';
import CustomTable from '@/components/KL-Table';
import KLDialog from '@/components/KL-Dialog';
import API from '@/api';

export default {
  name: 'index',
  components: {
    CustomTable,
    KLDialog,
  },
  data() {
    return {
      isEdit: false,
      listQuery: { pageNo: 1, pageSize: 10 },
      filterForm: {},
      total: 0,
      tableData: [],
      productDialogVisible: false,
      productForm: {},
      productFormRules: {
        name: [{ required: true, message: '请输入能力名称' }, { max: 128, message: '客户名称不能超过128个字符' }],
        type: [
          { required: true, message: '请输入能力英文标识' },
          { max: 64, message: '英文标识名称不能超过64个字符' },
          { pattern: /^\w+$/, message: '英文标识只能输入英文数字下划线' }],
        instruction: [{ max: 32, message: '客户维护人不能超过32个字符' }],
        note: [{ max: 16, message: '介绍人不能超过16个字符' }],
      },
      selectRows: [],
    };
  },
  created() {
    this.handleGetList();
  },
  filters: {
    formatDate(val) {
      return Moment(val).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  methods: {
    handleSearch() {
      this.listQuery.pageNo = 1;
      this.handleGetList();
    },
    handleSelectionChange(row) {
      this.selectRows = row;
    },
    handleBatchDelete() {
      console.log(this.selectRows);
      const params = {
        ids: this.selectRows.map((item) => item.id),
      };
      this.$confirm('确认删除当前选中的能力?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        API.deleteAlgorithm(params).then((res) => {
          if (res.status === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            const totalPage = Math.ceil(
              (this.total - 1) / this.listQuery.pageSize,
            ); // 总页数
            this.listQuery.pageNo = this.listQuery.pageNo > totalPage
              ? totalPage
              : this.listQuery.pageNo;
            this.listQuery.pageNo = this.listQuery.pageNo < 1 ? 1 : this.listQuery.pageNo;
            this.handleGetList();
          }
        });
      }).catch((err) => err);
    },
    handleDelete(row) {
      console.log(row);
      const params = {
        ids: [row.id],
      };
      this.$confirm('确认删除此能力?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        API.deleteAlgorithm(params).then((res) => {
          if (res.status === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            const totalPage = Math.ceil(
              (this.total - 1) / this.listQuery.pageSize,
            ); // 总页数
            this.listQuery.pageNo = this.listQuery.pageNo > totalPage
              ? totalPage
              : this.listQuery.pageNo;
            this.listQuery.pageNo = this.listQuery.pageNo < 1 ? 1 : this.listQuery.pageNo;
            this.handleGetList();
          }
        });
      }).catch((err) => err);
    },
    handleAdd() {
      this.productForm = {};
      this.productDialogVisible = true;
      this.isEdit = false;
      this.$nextTick(() => {
        this.$refs.productForm.clearValidate();
      });
    },
    handleCloseDialog() {
      this.productForm = {};
      this.$refs.productForm.clearValidate();
      this.productDialogVisible = false;
    },
    handleEdit(row) {
      this.productForm = { ...row };
      this.productDialogVisible = true;
      this.isEdit = true;
      this.$nextTick(() => {
        this.$refs.productForm.clearValidate();
      });
    },
    // 提交新增
    handleSubmit() {
      this.$refs.productForm.validate((validate) => {
        if (validate) {
          const params = {
            ...this.productForm,
          };
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });
          if (!this.isEdit) {
            API.insertAlgorithm(params).then((res) => {
              loading.close();
              if (res.status === 200) {
                this.listQuery.pageNo = 1;
                this.handleGetList();
                this.handleCloseDialog();
              }
            }).catch(() => {
              loading.close();
            });
          } else {
            delete params.createTime;
            delete params.creator;
            delete params.creatorId;
            API.modifyAlgorithm(params).then((res) => {
              loading.close();
              if (res.status === 200) {
                this.handleGetList();
                this.handleCloseDialog();
              }
            }).catch(() => {
              loading.close();
            });
          }
        }
      });
    },
    handleSizeChange(val) {
      this.listQuery.pageNo = 1;
      this.listQuery.pageSize = val;
      this.handleGetList();
    },
    handleCurrentChange(val) {
      this.listQuery.pageNo = val;
      this.handleGetList();
    },
    handleGetList() {
      const params = {
        ...this.filterForm,
        ...this.listQuery,
      };
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      API.getAlgorithm(params).then((res) => {
        loading.close();
        if (res.status === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      }).catch(() => {
        loading.close();
      });
    },
  },
};
</script>
<style scoped lang="scss">
.product {
  background: transparent;
  height: 100%;
  width: 100%;
  .title-bar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    .title {
      display: flex;
      align-items: center;
      .main {
        font-size: 20px;
        font-weight: 900;
        color: rgba(0, 0, 0, 0.6);
      }
      .sub {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
  .btn-handler {
    width: 160px;
  }

  .tools {
    display: flex;
    justify-content: space-between;

    .filter-wrapper {
      .search-input {
        width: 240px;
        height: 40px;
        font-size: 18px;
        line-height: 40px;

        /deep/ .el-input__inner {
          border-radius: 20px;
          padding-left: 35px;
        }

        /deep/ .el-input__prefix {
          left: 13px;
        }
      }
    }

    .btn-wrapper {
      /deep/ .el-button {
        width: 160px;
        height: 40px;
        color: rgba(154, 154, 154, 1);
      }

      /deep/ .el-button--primary {
        color: #fff;
      }
    }
  }
  .listLogo {
    padding-bottom: 20px;
    img {
      width: 28px;
      height: 20px;
    }
    span {
      font-size: 20px;
      padding-left: 10px;
    }
  }
  .content {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 152px);
    .table {
      margin-bottom: 30px;
    }

    .pagination {
      text-align: right;
    }
  }
  .titileContent {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
    margin-bottom: 20px;
    height: 88px;
    padding:0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .formContainer {
      height: 40px;
    }
  }
  .btn-table {
    font-size: 18px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    & + .btn-table {
      margin-left: 40px;
    }
  }
  .mute {
    color: rgba(1, 195, 141, 0.43);
  }
}
</style>
